import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Form, Row } from "antd";
import { observer } from "mobx-react-lite";
import { ContentBlockerField, DEFAULT_LANGUAGE, EExtendsMergeStrategy, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { useStores } from "../../../../../../store/root.js";
import { defaultTranslationFlexNamePath, isExtendedFieldHidden } from "../../../../../../util/template/form.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { getQuillEditorWrapperPropsDefaultLang, hasTranslationFlagsChanged } from "../../../../../../util/translation.js";
import { QuillEditorFormField } from "../../../../../third-party/quill-editor-form.js";
import { QuillSimpleHtmlContent } from "../../../../../third-party/quill-simple-html-content.js";
import { LanguageIcon } from "../../fields/translation/language-icon-addon/language-icon.js";
import { TranslationQuillFormFields } from "../../fields/translation/language-quill-input/language-quill-form-fields.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
const FormFieldContentBlockerTemplateDescription = observer(()=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore, rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const { isTranslationMode } = translationSettings;
    // Triggers form item re-render on translation mode toggle
    const lastKnownTranslationMode = isTranslationMode;
    const hasCreatorRole = rcbAuthenticationStore.hasRole(EUserRole.Creator);
    const form = Form.useFormInstance();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.Description,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        forceHiddenFormCallback: isExtendedFieldHidden(ContentBlockerField.Description, hasCreatorRole),
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ContentBlockerField.Description, t),
            extra: t("You can give your visitors further explanations why a content has been blocked or, for example, how they can contact you alternatively instead of agreeing to load the contact form. The description is displayed only in visual content blockers."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || hasTranslationFlagsChanged(prev, next, ContentBlockerField.Description) || lastKnownTranslationMode !== isTranslationMode,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsxs(TemplateMetaDataExtendsStrategyFormField, {
                        extendsFieldName: ContentBlockerField.Description,
                        disableStrategies: [
                            ...getDisableStrategies()
                        ],
                        defaultStrategy: EExtendsMergeStrategy.Overwrite,
                        onKeepContent: extended && /*#__PURE__*/ _jsx(QuillSimpleHtmlContent, {
                            value: extended[ContentBlockerField.Description],
                            readOnly: true
                        }),
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                gutter: [
                                    10,
                                    10
                                ],
                                style: {
                                    flexFlow: "row"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        flex: 1,
                                        children: /*#__PURE__*/ _jsx(QuillEditorFormField, {
                                            namePath: ContentBlockerField.Description,
                                            quillEditorProps: {
                                                readOnly: !hasCreatorRole,
                                                ...getQuillEditorWrapperPropsDefaultLang(ContentBlockerField.Description, form)
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        flex: "0",
                                        children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                            lang: DEFAULT_LANGUAGE,
                                            flexPathConfig: {
                                                absolute: {
                                                    namePath: ContentBlockerField.Description,
                                                    translationNamePath: defaultTranslationFlexNamePath(ContentBlockerField.Description)
                                                }
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(TranslationQuillFormFields, {
                                flexPathConfig: {
                                    absolute: {
                                        namePath: defaultTranslationFlexNamePath(ContentBlockerField.Description)
                                    }
                                }
                            })
                        ]
                    })
                });
            }
        })
    });
});
export { FormFieldContentBlockerTemplateDescription };
